module.exports = __webpack_public_path__ + "location-choose-image.svg?3580734742af146181f040455d0024db";